module.exports = __webpack_public_path__ + "c97d91edecb4f8875809b1755cecb52b.fbx";